import styled from 'styled-components'

export const TextInput = styled.input`
	background: #FDFDFD;
	border: 1px solid #C6DEE9;
	border-radius: 10px;
	resize: none;
	
	padding: 17px 13px;
	font-size: 1em;
	line-height: 1em;
	height: 50px;
	color: inherit;
	min-width: 0;

	::placeholder {
		color: #63A5C0;
	}
`
